import { LearningSectionLayoutJsonModel } from '../../learning-section-layout/learning-section-layout.json.model';

export namespace LearningSectionLayoutActions {

  export class Delete {
    static readonly type = getActionName('Delete');

    constructor(readonly payload: LearningSectionLayoutJsonModel) {
    }
  }

  export class Fetch {
    static readonly type = getActionName('Fetch');
    constructor(
      public overrideOptions?: {
        pageNumber?: number
        pageSize?: number
        skipStoreDispatch?: boolean
      }
    ) {}
  }

  export class FetchAppend {
    static readonly type = getActionName('Fetch and append');
  }

  export class FetchSuccess {
    static readonly type = getActionName('Fetch success');

    constructor(readonly payload: LearningSectionLayoutJsonModel[]) {
    }
  }

  export class FetchSuccessAppend {
    static readonly type = getActionName('Fetch success append');

    constructor(readonly payload: LearningSectionLayoutJsonModel[]) {
    }
  }

  function getActionName(type: string) {
    return `[LearningSectionLayout] ${type}`;
  }

}
